import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";

import console from "../utils/functions/console";
import KurslisteStorage from "../storage/kursliste-storage";
import { RESPONSE_HEADER } from "../utils/enums";

export const fetchKursliste = createAsyncThunk("kursliste/fetchData", ({ apiCall }, _trunkApi) => {
  if (typeof apiCall !== "function") return Promise.reject(new Error("invalid api call kursliste/fetchData"));
  return new Promise((resolve, reject) => {
    try {
      apiCall((error, data, response) => {
        if (response && data && !error) {
          if (data.header && data.header.status === RESPONSE_HEADER.STATUS.SUCCESSFUL) {
            resolve(data);
          } else if (data.header && data.header.errorNr) {
            reject(new Error("Fehler " + data.header.errorNr + ": Die Liste der Kurse konnte nicht ermittelt werden"));
          } else {
            reject(new Error("Bei der Ermittlung der Kursliste ist ein Fehler aufgetreten"));
          }
        } else {
          console.error(error);
          reject(new Error("Die Kursliste konnten nicht geladen werden"));
        }
      });
    } catch (e) {
      console.error(e);
      reject(e);
    }
  });
});

const kurslisteSlice = createSlice({
  name: "kursliste",
  initialState: new KurslisteStorage(),
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchKursliste.pending, (state) => {
        state.failed(null);
        state.loading(true);
        return state;
      })
      .addCase(fetchKursliste.fulfilled, (state, action) => {
        let res = action.payload || {};
        state.setListe({ liste: res.liste, timestamp: res.timestamp });
        state.loading(false);
        return state;
      })
      .addCase(fetchKursliste.rejected, (state, action) => {
        state.failed(action.error);
        state.setListe({});
        state.loading(false);
        return state;
      })
      .addCase(createAction("METALS_SET_BASE_DATA"), (state, action) => {
        const res = action.payload || {};
        const basedata = res.basedata || {};
        state.setKinds(basedata.kinds);
        state.setMakes(basedata.makes);
        return state;
      });
  }
});
export const { setListe } = kurslisteSlice.actions;
export const kurslisteActions = kurslisteSlice.actions;
export default kurslisteSlice.reducer;
